import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=c21a769c&scoped=true"
import script from "./ImportData.vue?vue&type=script&lang=js"
export * from "./ImportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a769c",
  null
  
)

export default component.exports